export class SearchData {
  category: string;
  city: string;
}
